import {Ticket} from 'attendee/Tickets/Ticket'
import {eventRoutes} from 'event/EventRoutes'
import React from 'react'
import {LocalLink} from 'i18n/LocalLink'
import {useI18n} from 'i18n/I18nContext'

export function EventListItem(props: {ticket: Ticket}) {
  const {t} = useI18n()
  const {ticket} = props
  const routes = eventRoutes(ticket.event)

  return (
    <tr key={ticket.id}>
      <td data-label={t('tickets.colNumber')}>
        <div className="attendant__serial">
          <span> {ticket.id} </span>
        </div>
      </td>
      <td data-label={t('tickets.colPrice')}>
        <div className="attendant__date">
          <span>
            {(() => {
              const face =
                ticket.price != null ? ticket.price : ticket.event.price
              return face === 0 || face === null
                ? t('eventRow.free')
                : `${Number(face).toFixed(2)} €`
            })()}
          </span>
        </div>
      </td>
      <td data-label={t('tickets.colTier')}>
        <div className="attendant__date">
          <span>{ticket.event_ticket?.name ?? '—'}</span>
        </div>
      </td>
      <td data-label={t('tickets.colEvent')}>
        <div>
          <LocalLink to={routes.root}>{ticket.event.name}</LocalLink>
        </div>
      </td>
      <td>
        <div className="attendant__status">
          <span className={'status__tag bg-green'}>
            {t('tickets.statusPaid')}
          </span>
        </div>
      </td>
      <td>
        <LocalLink
          to={routes.preview}
          target="_blank"
          className="fill__btn w-100"
          style={{justifyContent: 'center'}}
        >
          {t('tickets.enterWithArrow')}{' '}
          <i className="fa-regular fa-angle-right"></i>
        </LocalLink>
      </td>
    </tr>
  )
}
